module.exports = __webpack_public_path__ + "258d0ffb2db51baa68b5573af6ba1a1e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-4.png
// module id = 2094
// module chunks = 0